import React, { useMemo } from 'react';
import { ResumePreviewProps } from './types';
import { ClassicTemplate } from './templates/ClassicTemplate';
import { DefaultTemplate } from './templates/DefaultTemplate';
import { CedarTemplate } from './templates/CedarTemplate';
import { AspenTemplate } from './templates/AspenTemplate';
import { SpruceTemplate } from './templates/SpruceTemplate';
import { HemlockTemplate } from './templates/HemlockTemplate';
import { MappleTemplate } from './templates/MappleTemplate';
import { BonsaiTemplate } from './templates/BonsaiTemplate';
import '../../../styles/resume-preview.css';

const TEMPLATES: Record<string, React.ComponentType<ResumePreviewProps>> = {
  classic: ClassicTemplate,
  default: DefaultTemplate,
  cedar: CedarTemplate,
  aspen: AspenTemplate,
  spruce: SpruceTemplate,
  hemlock: HemlockTemplate,
  mapple: MappleTemplate,
  bonsai: BonsaiTemplate,
};

export const ResumePreview: React.FC<ResumePreviewProps> = ({
  data,
  pageSize,
  margins,
  template = 'classic',
  activeField,
  onFieldClick,
  sectionOrder,
  structures,
  settings,
}) => {
  const TemplateComponent = useMemo(() => {
    return TEMPLATES[template] || DefaultTemplate;
  }, [template]);

  return (
    <TemplateComponent
      data={data}
      pageSize={pageSize}
      margins={margins}
      template={template}
      activeField={activeField}
      onFieldClick={onFieldClick}
      sectionOrder={sectionOrder}
      structures={structures}
      settings={settings}
    />
  );
};

